enum TriggerType {
  MANUAL = 0,
  ASSESSMENT_PERIOD_OPEN = 1,
  ASSESSMENT_PERIOD_CLOSE = 2,
  SURVEY_COMPLETE = 3,
}

export default TriggerType;
